<agr-dialog
  [data]="data"
  (close)="cancel()"
  (cancel)="stepBack()"
  (alt)="stepForward()"
  (confirm)="addToSilo()"
  class="product-wizard-dialog"
  data-test="product-wizard-dialog"
>
  <div class="flex flex__column spacing--margin-vertical">
    <div class="flex__child spacing--margin-right white-space--no-wrap" *ngIf="(isLtSm$ | async) === false">
      <div class="text--small text--gray">
        {{ 'product.product' | translate }}
      </div>
      <div>{{ siloProductItem.title }}</div>
    </div>
    <div class="flex__child" *ngIf="(isLtSm$ | async) === false">
      <div class="text--small text--gray">
        {{ 'product.product-code' | translate }}
      </div>
      <div>{{ siloProductItem.externalId }}</div>
    </div>
    <div class="flex__child">
      <div class="text--small text--gray">
        {{ 'product.minimum-order-unit-quantity' | translate }}
      </div>
      <div>
        {{ siloProductItem.orderingInformation.minimumOrderUnitQuantity }}
        {{ 'unit.' + siloProductItem.orderingInformation.orderUnit | translate }}
      </div>
    </div>
    <div class="flex__child">
      <div class="text--small text--gray">
        {{ 'product.increase-order-unit-quantity' | translate }}
      </div>
      <div>
        {{ siloProductItem.orderingInformation.increaseOrderUnitQuantity }}
        {{ 'unit.' + siloProductItem.orderingInformation.orderUnit | translate }}
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div>
    <mat-stepper
      #wizardStepper
      class="product-wizard-dialog__stepper"
      data-test="product-wizard-dialog__stepper"
      (selectionChange)="handleStepperSelectionChange($event)"
      [orientation]="orientation"
    >
      <!-- Quantity -->
      <mat-step [hasError]="quantityIsValid === false" [errorMessage]="'product.wizard.quantity.tab-invalid' | translate">
        <ng-template matStepLabel>{{ 'product.wizard.quantity.title' | translate }}</ng-template>
        <app-product-quantity
          (quantityIsValid)="handleQuantityIsValidChange($event)"
          [quantityItem]="quantityItem"
          (quantityChange)="handleQuantityChange($event)"
        >
        </app-product-quantity>
      </mat-step>

      <!-- Silos selection -->
      <mat-step [hasError]="silosAreValid === false" [optional]="silosAreOptional === true" [errorMessage]="'product.wizard.silo.tab-invalid' | translate">
        <ng-template matStepLabel>{{ 'product.wizard.silo.title' | translate }}</ng-template>
        <app-productlist-silo
          [quantity]="siloProductItem.quantity"
          [selectedSiloId]="data.silo.id"
          [orderingInformation]="siloProductItem.orderingInformation"
          (silosChange)="handleSilosChange($event)"
        >
        </app-productlist-silo>
      </mat-step>

      <!-- Supplements -->
      <mat-step [hasError]="productSupplementsIsValid === false" *ngIf="data.skuCatalogItem.hasProductSupplements === true">
        <ng-template matStepLabel>{{ 'product.wizard.supplement.title' | translate }}</ng-template>
        <app-product-supplement
          [lineItem]="supplementLineItem"
          [validate]="true"
          (productSupplementsChange)="handleProductSupplementsChange($event)"
          (productSupplementsIsValid)="handleProductSupplementsIsValidChange($event)"
        >
        </app-product-supplement>
      </mat-step>
    </mat-stepper>
  </div>
</agr-dialog>
